import { Button, Card, Drawer, Form, Input, notification } from 'antd'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import InputBox from '../../../components/_utils/InputBox'
import { updateWithdrawalIssueStatus } from '../actions/commissionAction'

let initState = {
  status: '',
  note: '',
  reason: ''
}
const { TextArea } = Input

const UpdateWithdrawalIssueStatus = props => {
  let dispatch = useDispatch()
  let { onClose, visible, withdrawalIssueId, onSubmit } = props

  let [state, setState] = useState(initState)
  let events = {
    setLocalState: data => {
      setState(prevState => {
        return {
          ...prevState,
          ...data
        }
      })
    },
    handleSubmit: async e => {
      e.preventDefault()
      if (!state.status) {
        notification.warn({ message: 'Please choose status.' })
        return
      }
      if (state.status == 'Approved') {
        if (!state.note) {
          notification.warn({ message: 'Enter Note' })
          return
        }
      }
      if (state.status == 'Rejected') {
        if (!state.reason) {
          notification.warn({ message: 'Enter Reason' })
          return
        }
      }
      let resp = await dispatch(updateWithdrawalIssueStatus({ ...state, withdrawalIssueId }))
      if (resp && resp.success) {
        onSubmit()
      }
    }
  }

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      title={'Update Status'}
      width={'30%'}>
      <div className={'unizportal'}>
        <Card bordered={false}>
          <Form>
            <Form.Item>
              <InputBox title={'Status*'}>
                <select className={'form-control'} value={state.status} onChange={({ target }) => {
                  events.setLocalState({ status: target.value, note: '', reason: '' })
                }}>
                  <option value={''}>Choose Status</option>
                  <option value={'Approved'}>Approve</option>
                  <option value={'Rejected'}>Reject</option>
                </select>
              </InputBox>
            </Form.Item>
            {state.status == 'Approved' ?
              <Form.Item>
                <InputBox title={'Note'}>
                  <TextArea
                    rows={7}
                    onChange={({ target }) => {
                      events.setLocalState({ note: target.value })
                    }}
                    name={'note'}
                    className={'form-control customTextArea'}
                    placeholder={'Note'}
                    value={state.note}
                  />
                </InputBox>
              </Form.Item> : null}
            {state.status == 'Rejected' ?
              <Form.Item>
                <InputBox title={'Reason*'}>
                  <TextArea
                    rows={7}
                    className={'form-control customTextArea'}
                    placeholder={'Reason'}
                    onChange={({ target }) => {
                      events.setLocalState({ reason: target.value })
                    }}
                    value={state.reason}
                  />
                </InputBox>
              </Form.Item> : null}
            <Form.Item className={'mt20 alignRight'}>
              <Button type='primary' onClick={events.handleSubmit}>
                SUBMIT
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </Drawer>
  )
}
export default UpdateWithdrawalIssueStatus
